import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  message?: string;
}

const sizeClasses = {
  sm: 'h-8 w-8 border-2',
  md: 'h-16 w-16 border-3',
  lg: 'h-32 w-32 border-4',
};

export function LoadingSpinner({ size = 'md', className, message }: LoadingSpinnerProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-4', className)}>
      <div
        className={cn(
          'animate-spin rounded-full border-b-2 border-medical-primary',
          sizeClasses[size]
        )}
        role="status"
        aria-label="Loading"
      />
      {message && <p className="animate-pulse text-sm text-muted-foreground">{message}</p>}
    </div>
  );
}

/**
 * Full page loading state for lazy-loaded route components
 */
export function PageLoadingFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-medical-light">
      <LoadingSpinner size="lg" message="Loading..." />
    </div>
  );
}

/**
 * Smaller loading state for component sections
 */
export function SectionLoadingFallback() {
  return (
    <div className="flex items-center justify-center p-8">
      <LoadingSpinner size="md" />
    </div>
  );
}

export default LoadingSpinner;
